import React from 'react';
import Link from '../Link';

interface ItunesButtonProps {
  appleLink: string;
}

const ItunesButton: React.FC<ItunesButtonProps> = ({ appleLink }) => {
  if (!appleLink || typeof appleLink !== 'string') return <div />;
  return (
    <Link
      className="bg-black f8 br1 white ph2 source-sans link pointer"
      target="_blank"
      to={appleLink}
    >
      iTunes
    </Link>
  );
};

export default ItunesButton;
